import axios from 'axios';
import qs from 'qs';
class ApiService {
    static login(userLogin) {
        return axios.post(`${this.apiURL}/login`, userLogin);
    }
    static signup(userSignup) {
        const data = {
            username: userSignup.username,
            rawPassword: userSignup.password
        };
        return axios.post(`${this.apiURL}/users/register`, data);
    }
    static refreshToken() {
        const refreshData = {
            'grant_type': 'refresh_token',
            'refresh_token': localStorage.getItem('refresh_token')
        };
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };
        return axios.post(`${this.apiURL}/oauth/access_token`, qs.stringify(refreshData), config);
    }
    static getCurrentUser() {
        return axios.get(`${this.apiURL}/users/current`);
    }
    static getCurrentUserAndRefreshTokenIfNeeded() {
        return new Promise(async (resolve, reject) => {
            const response = await this.getCurrentUser();
            if (response.data.loggedIn === true) {
                resolve(response);
            }
            else if (response.data.loggedIn === false && localStorage.getItem('refresh_token') !== null) {
                try {
                    const tokenRefreshResponse = await this.refreshToken();
                    localStorage.setItem('access_token', tokenRefreshResponse.data.access_token);
                    axios.defaults.headers.common['Authorization'] = `Bearer ${tokenRefreshResponse.data.access_token}`;
                    const response2 = await this.getCurrentUser();
                    resolve(response2);
                }
                catch (e) {
                    reject(e);
                }
            }
            else {
                resolve(response);
            }
        });
    }
    static getDefault() {
        return axios.get(`${this.apiURL}/default`);
    }
    // ============
    // Cash Entries
    // ============
    static getCashEntries() {
        return axios.get(`${this.apiURL}/cash-entries`);
    }
    static getCashEntriesForUser(userId) {
        return axios.get(`${this.apiURL}/users/${userId}/cash-entries`);
    }
    static createCashEntry(cashEntry) {
        return axios.post(`${this.apiURL}/cash-entries`, cashEntry);
    }
    static updateCashEntry(cashEntry) {
        return axios.put(`${this.apiURL}/cash-entries/${cashEntry.id}`, cashEntry);
    }
    static deleteCashEntry(cashEntry) {
        return axios.delete(`${this.apiURL}/cash-entries/${cashEntry.id}`);
    }
    // =============
    // User Balances
    // =============
    static getCurrentUserBalances() {
        return axios.get(`${this.apiURL}/user-balances/current-user`);
    }
    static updateUserBalance(userBalance) {
        return axios.put(`${this.apiURL}/user-balances/${userBalance.id}`, userBalance);
    }
    // =============
    // Cash entry categories
    // =============
    static getCashEntryCategoriesForUser(userId) {
        return axios.get(`${this.apiURL}/users/${userId}/cash-entry-categories`);
    }
    static createOrUpdateCashEntryCategoriesBatch(cashEntryCategories) {
        return axios.post(`${this.apiURL}/cash-entry-categories/batch`, cashEntryCategories);
    }
    static deleteCashEntryCategory(categoryId) {
        return axios.delete(`${this.apiURL}/cash-entry-categories/${categoryId}`);
    }
}
// @ts-ignore
ApiService.apiURL = APP.env.https://raha.priki.ee/api;
export default ApiService;
